import { render, staticRenderFns } from "./WriteOffBonuses.vue?vue&type=template&id=1e7f555a&scoped=true&"
import script from "./WriteOffBonuses.vue?vue&type=script&lang=ts&"
export * from "./WriteOffBonuses.vue?vue&type=script&lang=ts&"
import style0 from "./WriteOffBonuses.vue?vue&type=style&index=0&id=1e7f555a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7f555a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconArrowLeft: require('/usr/www/nuxt/components/Icon/IconArrowLeft.vue').default,IconBonus: require('/usr/www/nuxt/components/Icon/IconBonus.vue').default})
